module.exports = __webpack_public_path__ + "media/images/app/products/index/types/rings-f6aba0a100697d4aaa8b2fcb3fb0c82a.webp";